import React, { Component } from 'react';
import {
  Modal,
  Select,
  Button,
  Spin,
  Col,
  Input,
  Switch,
  Form,
  message,
} from 'antd';
import {
  addNewProcedure,
  fetchProcedures,
} from '../../services/api/cashless-procedures';
import { showError } from '../../actions';
// import AddNewVaccination from './addNewVaccination';

class AddProcedure extends Component {
  constructor(props) {
    super(props);
    console.log(props, 'props');
    this.state = {
      loading: false,
      allProcedures: [],
      selectedProcedure: '',
      discount: 0.00,
      mrp: 0,
      skipIds: this.props.skipIds,
      selectedProcedureType: 'cashless_derma',
      showErr: false,
      errMessage: '',
    };
  }
  componentDidMount() {
    this.getAllProcedures();
  }

  getAllProcedures = async () => {
    this.setState({ loading: true });
    fetchProcedures()
      .then((res) => {
        this.setState({
          allProcedures: Object.values(res.body.data),
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  submitProcedure = async () => {
    const { selectedProcedure, discount, mrp } = this.state;
    const id = parseInt(selectedProcedure);
    const body = {
      networkCenterId: parseInt(this.props.centerId),
      procedureId: id,
      discount,
      mrp,
    };
    console.log(body, '[body]');
    addNewProcedure(body)
      .then((res) => {
        console.log(res);
        if (res.body.message === 'success') {
          this.props.handleClose();
          this.props.reload();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          showErr: true,
          errMessage:
            err.response.data.errorMessage ||
            Object.values(err.response.data.err)[0].msg ||
            'Invalid fields',
        });
      });
  };

  render() {
    const {
      allProcedures,
      discount,
      mrp,
      selectedProcedure,
      skipIds,
      selectedProcedureType,
      showErr,
      errMessage,
      loading,
    } = this.state;
    console.log(allProcedures);
    return (
      <>
        <Modal
          visible={this.props.modalIsOpen}
          title="Add New Procedure For Center"
          onCancel={() => {
            this.props.handleClose();
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                this.props.handleClose();
              }}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={
                selectedProcedure === '' || mrp === 0
              }
              loading={loading}
              onClick={this.submitProcedure}
            >
              Submit
            </Button>,
          ]}
        >
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            //   initialValues={{ remember: true }}
            //   onFinish={this.onFinish}
            //   onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            {showErr && <p style={{ color: 'red' }}>{errMessage}</p>}
            <Form.Item label="Select Procedure Type" name="procedureTypeSelect">
              <Select
                style={{ width: '50%', marginLeft: '10px' }}
                value={selectedProcedureType}
                defaultValue={''}
                onChange={(value) =>
                  this.setState({
                    selectedProcedureType: value,
                    selectedProcedure: '',
                    showErr: false,
                  })
                }
              >
                <Select.Option value="cashless_derma">Derma</Select.Option>
                <Select.Option value="cashless_minor">Minor</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label="Select Procedure" name="procedureSelect">
              <Select
                style={{ width: '50%', marginLeft: '10px' }}
                value={selectedProcedure}
                defaultValue={''}
                onChange={(value) =>
                  this.setState({ selectedProcedure: value, showErr: false })
                }
              >
                {allProcedures
                  .filter(
                    (p) =>
                      !skipIds.includes(p.procedureId + '') &&
                      p.procedureType === selectedProcedureType
                  )
                  .map((p) => (
                    <Select.Option value={p.procedureId}>
                      {p.procedureName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item label="MRP" name="procedureMrp">
              <Input
                type="number"
                style={{ width: '50%', marginLeft: '10px' }}
                value={mrp}
                onChange={(event) => {
                  this.setState({
                    mrp: parseInt(event.target.value),
                    showErr: false,
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Discount (%)" name="procedureDiscount">
              <Input
                type="number"
                min={0}
                max={100}
                step={0.01}
                precision={2}
                style={{ width: '50%', marginLeft: '10px' }}
                value={discount}
                onChange={(event) => {
                  let newDiscount = parseFloat(
                    parseFloat(event.target.value).toFixed(2)
                  );
                  newDiscount = newDiscount > 100 ? 100 : newDiscount ;
                  this.setState({
                    discount: newDiscount,
                    showErr: false,
                  });
                }}
              />
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
}

export default AddProcedure;
